// removed by extract-text-webpack-plugin
module.exports = {"loaderIcnWrapper":"loader-icn-wrapper--iDLua","loaderIcn":"loader-icn--1iO2V","loadingMsg":"loading-msg--xUKk4"};


//////////////////
// WEBPACK FOOTER
// ./app/components/commons/loader/loader.scss
// module id = 9nHZ
// module chunks = 1